import { FC } from "react";
import { ILink } from "src/@types";
import { FooterLinkItem } from "./FooterLinkItem";

interface Props {
  links: ILink[];
}

export const FooterLinks: FC<Props> = ({ links }) => (
  <ul className="flex flex-col gap-2 lg:gap-6">
    {links.map(({ id, ...link }) => (
      <FooterLinkItem key={id} {...link} />
    ))}
  </ul>
);
